/** Discord onboarding invites by platform plan */
export const DISCORD_INVITES = {
  growth: 'https://discord.gg/sfXByfNHN6',
  general: 'https://discord.gg/sfXByfNHN6',
  pro: 'https://discord.gg/NtmTuUKDT3',
} as const;

export type DiscordPlanKey = keyof typeof DISCORD_INVITES;

export function isDiscordPlan(plan?: string | null): plan is DiscordPlanKey {
  const key = String(plan || '').toLowerCase();
  return key === 'growth' || key === 'general' || key === 'pro';
}

export function getDiscordInviteForPlan(plan?: string | null): string | null {
  const key = String(plan || '').toLowerCase();
  if (key === 'growth' || key === 'general' || key === 'pro') {
    return DISCORD_INVITES[key];
  }
  return null;
}
